import { motion } from 'framer-motion';
import { CalendarDays, Clock3, MapPin, Pencil } from 'lucide-react';
import Editable from './Editable';
import { useTexts } from './TextsContext';

const items = [
  { icon: CalendarDays, label: 'wedding date', id: 'detailDate', ph: '[ Wedding Date ]' },
  { icon: Clock3, label: 'ceremony time', id: 'detailTime', ph: '[ Ceremony Time ]' },
  { icon: MapPin, label: 'venue', id: 'detailVenue', ph: '[ Venue, City ]' },
];

export default function Details() {
  const { canEdit } = useTexts();

  const focusEditable = (e) => {
    const ed = e.currentTarget.querySelector('[contenteditable]');
    if (ed && document.activeElement !== ed) ed.focus();
  };

  return (
    <section className="relative py-16 md:py-24" data-testid="details">
      <div className="mx-auto max-w-4xl text-center px-2">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8 }}
          className="font-display text-3xl md:text-4xl text-kula-maroon"
        >
          বিবাহলগ্ন
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, delay: 0.12 }}
          className="mt-2 font-english italic text-kula-ink/60"
        >
          details of the day
        </motion.p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-7">
          {items.map((it, i) => (
            <motion.div
              key={it.id}
              initial={{ opacity: 0, y: 34 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`detail-card ${canEdit ? 'cursor-text' : ''}`}
              onClick={canEdit ? focusEditable : undefined}
              data-testid={`detail-card-${it.id}`}
            >
              <span className="icon-ring">
                <it.icon size={20} strokeWidth={1.6} />
              </span>
              <p className="mt-4 flex items-center justify-center gap-1.5 font-english text-[11px] uppercase tracking-[0.28em] text-kula-red">
                {it.label}
                {canEdit && <Pencil size={11} className="text-kula-gold" aria-label="tap to edit" />}
              </p>
              <div className="mt-2 font-bengali text-lg md:text-xl text-kula-ink leading-snug">
                <Editable id={it.id} placeholder={it.ph} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
